import React, {Component} from "react";
import * as dateFns from "date-fns";
import {withFormsy} from "formsy-react";

const WeekInput = (props) => {
    const errorMessage = props.getErrorMessage();
    let className = props.showRequired() ? 'required ' : '';

    className += !props.isValid() ? 'text-danger' : '';
    let inputClassName = !props.isValid() ? 'is-invalid' : '';

    let currentValue = props.getValue()
    return (
        <div className={"form-group " + className}>
            <input
                type='tel'
                className={"form-control " + inputClassName}
                minLength={0}
                maxLength={40}
                name={props.name}
                defaultValue={props.defaultValue}
                value={TB.isNaN(parseInt(currentValue)) ? '' : currentValue}
                onKeyDown={e => {
                    if (e.keyCode === 9) e.preventDefault();
                }}
                onChange={e => {
                    let value = e.target.value;

                    try {
                        if (value.length === 3 && String(props.getValue()).length === 2) {
                            function findFirstDiffPos(a, b) {
                                let i = 0;
                                if (a == b) return -1;
                                while (a[i] == b[i]) i++;

                                return i;
                            }

                            let diffIndex = findFirstDiffPos(String(props.getValue()), value)

                            switch (diffIndex) {
                                case 0:
                                    value = value.substring(0, 1);
                                    break;
                                case 1:
                                    value = value.substring(1, 2);
                                    break;
                                default:
                                case 2:
                                    value = value.slice(-1);
                            }
                        }
                    } catch (e) {
                        console.warn(e);
                    }

                    let numberValue = parseInt(value);

                    if (!TB.isNaN(numberValue) && (numberValue > 40)) {
                        value = value.slice(1);
                        if (parseInt(value) > 40) {
                            value = value.slice(0, 1);
                        }
                    }

                    if (!TB.isNaN(numberValue) && numberValue < 0) {
                        value = Math.abs(numberValue).toString()
                    }
                    if (value && value.length > 2) {
                        value = value.slice(0, 2);
                    }
                    // if (value && !value.length) {
                    //     value = props.getValue() || 0;
                    // }

                    if (!value && !value.length) {
                        value = null;
                    }

                    props.setValue(value)
                }}
                autoComplete='off'
                disabled={props.disabled}
                required={true}
                onBlur={e => {
                    if (props.onBlur) props.onBlur();
                    if (
                        (!TB.isInteger(currentValue) && TB.isEmpty(currentValue))
                        || !currentValue
                        || currentValue === ''
                    ) {
                        props.setValue('0');
                    }
                }}
                onFocus={(event) => {
                    if (props.onFocus) props.onFocus()
                }}
            />

            {errorMessage && (
                <div className="invalid-feedback">
                    <div>{errorMessage}</div>
                </div>
            )}
        </div>
    )
}

const WeekInputComponent = withFormsy(WeekInput)

class Calendar extends Component {

    constructor(props) {
        super(props);
        let months = [];

        let currentMonth = dateFns.startOfMonth(new Date());

        for (let index = 0; index < 4; index++) {
            let month = dateFns.addMonths(currentMonth, index);

            months.push({month, index})
        }
        this.state = {
            currentMonth,
            selectedDate: new Date(),
            months
        };
    }


    renderHeader() {
        const dateFormat = "MMM";
        const months = [];


        for (let month of this.state.months) {
            months.push(
                <div className={TB.mapClass("col col-center", {
                    "selected": dateFns.isSameMonth(month.month, this.state.currentMonth)
                })} key={`month-${month.index}`}>
                     <span onClick={() => {
                         this.setState({currentMonth: month.month})
                     }}>
                         {dateFns.format(month.month, dateFormat)}
                    </span>
                </div>
            );
        }
        let current = TB.find(this.state.months, ['month', this.state.currentMonth])
        let currentIndex = current ? current.index : 0;

        return (
            <div className="header row flex-middle flex">
                {months}
                <div className="col-scrollbar">
                    <button
                        type='button'
                        disabled={this.props.isLoading}
                        className={'btn btn-sm left-scroll'}
                        onClick={() => {
                            let prevIndex = currentIndex === 0 ? (this.state.months.length - 1) : currentIndex - 1;

                            let currentMonth = TB.find(this.state.months, ['index', prevIndex]);
                            if (currentMonth) {
                                return this.setState({currentMonth: currentMonth.month})
                            }
                        }}>
                        <i className={'fa fa-caret-left'}/>
                    </button>

                    <button
                        type='button'
                        className={'btn btn-sm right-scroll'}
                        disabled={this.props.isLoading}
                        onClick={() => {
                            let nextIndex = ((currentIndex + 1) >= this.state.months.length) ? 0 : currentIndex + 1;
                            let currentMonth = TB.find(this.state.months, ['index', nextIndex]);
                            if (currentMonth) {
                                return this.setState({currentMonth: currentMonth.month})
                            }
                        }}>
                        <i className={'fa fa-caret-right'}/>

                    </button>
                </div>
                <div className="col col-center header-info">
                    <p>{this.props.readOnly ?
                        `Number of hours available to work per week on new ${laravel.platform_name} projects in` :
                        `How many hours are you free to work on new ${laravel.platform_name} projects in`}&nbsp;
                        <b>{dateFns.format(this.state.currentMonth, "MMMM, yyyy")}?</b>
                    </p>
                </div>
            </div>
        );
    }

    renderDays() {
        const dateFormat = "iiiii";
        const days = [];

        let startDate = dateFns.startOfWeek(this.state.currentMonth);

        for (let i = 0; i < 7; i++) {
            days.push(
                <div className="col col-center" key={i}>
                    {dateFns.format(dateFns.addDays(startDate, i), dateFormat)}
                </div>
            );
        }

        return (
            <div className="days flex row">

                {days}
                <div className="col col-center day-info"></div>

            </div>
        )
    }

    renderCells() {
        const {currentMonth, selectedDate} = this.state;
        const monthStart = dateFns.startOfMonth(currentMonth);
        const monthEnd = dateFns.endOfMonth(monthStart);
        const startDate = dateFns.startOfWeek(monthStart);
        const endDate = dateFns.endOfWeek(monthEnd);

        const dateFormat = "d";
        const rows = [];

        let days = [];
        let day = startDate;
        let formattedDate = "";

        while (day <= endDate) {
            for (let i = 0; i < 7; i++) {
                formattedDate = dateFns.format(day, dateFormat);
                let sameDay = dateFns.isSameDay(day, selectedDate)

                days.push(
                    <div
                        key={`day-${day}`}
                        className={TB.mapClass('col cell', {
                            // highlight days being currently edited
                            "selected": this.props.isEditing && this.state.focusWeek && dateFns.isSameWeek(day, this.state.focusWeek),
                            // Disable all days in the past or in nonactive month
                            "disabled": (dateFns.isPast(day) && !sameDay) || !dateFns.isSameMonth(day, monthStart),
                            "today": sameDay,
                        })}>
                        <span className="number">{formattedDate}</span>
                    </div>
                );
                day = dateFns.addDays(day, 1);
            }
            let week = dateFns.startOfISOWeek(day);
            let weekFormat = TB.moment(week).utcOffset("+00:00", true).format("YYYY-MM-DDTHH:mm:ssZ");
            let past = dateFns.isPast(dateFns.endOfISOWeek(day)) || !dateFns.isSameMonth(monthStart, week);

            rows.push(
                <div className="row flex" key={day}>
                    {days}
                    <div className="col cell input">
                        {!past && (
                            <div className="availability-hours">
                                <WeekInputComponent
                                    name={'work_schedule_weeks[' + weekFormat + ']'}
                                    defaultValue={this.props.availableHoursPerWeek }
                                    // value={this.props.workScheduleWeeks[weekFormat] || this.props.availableHoursPerWeek || ''}
                                    value={this.props.workScheduleWeeks[weekFormat]}

                                    onFocus={e => {
                                        this.setState({focusWeek: week})
                                    }}
                                    onBlur={e => {
                                        this.setState({focusWeek: undefined})
                                    }}
                                    disabled={!this.props.isEditing}
                                />
                                <p>hours</p>
                            </div>
                        )}
                    </div>

                </div>
            );
            days = [];
        }
        return <div className="body">{rows}</div>;
    }

    onDateClick = day => {
        this.setState({
            selectedDate: day
        });
    };

    nextMonth = () => {
        this.setState({
            currentMonth: dateFns.addMonths(this.state.currentMonth, 1)
        });
    };

    prevMonth = () => {
        this.setState({
            currentMonth: dateFns.subMonths(this.state.currentMonth, 1)
        });
    };

    render() {
        return (
            <div className="calendar">
                <div className="row p0 year-header">
                    <div className="col year">
                        <b>{dateFns.format(this.state.currentMonth, "yyyy")}</b>
                    </div>
                    <div className="col spacer">
                    </div>
                </div>
                {this.renderHeader()}
                {this.renderDays()}
                {this.renderCells()}
            </div>
        );
    }
}

export {
    WeekInputComponent
}
export default Calendar;